<template>
  <div>
    <div
      class="d-flex justify-space-between align-center"
      style="padding-bottom: 6px"
    >
      <span class="offset-title">{{ callEditedInfo?.modal_title }}</span>
      <div style="border: 0.5px solid #e2e8f0">
        <v-btn icon @click="closeCallEditedModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
    <v-divider></v-divider>

    <v-container>
      <v-row>
        <v-col
          v-for="(field, index) in callEditedInfo.data"
          :key="index"
          cols="12"
          class="pb-3"
        >
          <template v-if="field.isEditable">
            <p class="input-label">
              {{ field.label }}
            </p>
            <v-text-field
              class="text-field"
              style="background-color: transparent"
              v-if="field.input === 'text'"
              v-model="field.value"
              hide-details
              filled
              dense
            ></v-text-field>
            <v-textarea
              class="text-field"
              style="background-color: transparent"
              v-else-if="field.input === 'textarea'"
              v-model="field.value"
              hide-details
              filled
              dense
            ></v-textarea>
          </template>
          <template v-else>
            <p class="input-label">
              {{ field.label }}
            </p>
            <v-text-field
              class="text-field"
              v-model="field.value"
              disabled
              hide-details
              filled
              dense
            ></v-text-field>
          </template>
        </v-col>
      </v-row>
    </v-container>

    <div class="d-flex justify-end" style="margin-top: 10px">
      <button class="button-cancel" @click="closeCallEditedModal">
        キャンセル
      </button>
      <button class="button-save" @click="updateCallDetail">保存</button>
    </div>
  </div>
</template>

<script>
import { UPDATE_CALL_DETAIL } from "@/store/_actiontypes";
import { mapActions } from "vuex";
import { interactionUpdate } from "@/helpers/helper";
import { INTERACTION_POINT } from '@/global/_constants';

export default {
  name: "CallEditModal",
  props: {
    callEditedInfo: {
      type: Object,
      required: true,
    },
    closeCallEditedModal: {
      type: Function,
      required: true,
    },
    showSnackbar: {
      type: Function,
      required: true,
    },
    getCallInformation: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      interactionUpdate,
      INTERACTION_POINT,
    };
  },
  mounted() {},
  methods: {
    ...mapActions("call", [UPDATE_CALL_DETAIL]),
    updateCallDetail() {
      const filteredData = this.callEditedInfo.data
        .filter((field) => field.field !== "N/A")
        .reduce((acc, field) => {
          acc[field.field] = field.value;
          return acc;
        }, {});
      this.UPDATE_CALL_DETAIL({
        session_id: this.callEditedInfo.session_id,
        data: filteredData,
      })
        .then((response) => {
          if (response) {
            this.showSnackbar("情報は正常に更新されました。", "success");
          }
          this.closeCallEditedModal();
          setTimeout(() => {
            this.getCallInformation();
          }, 1000);
        })
        .catch((error) => {
          console.error("Error updating call detail:", error);
        }).finally(() => {
        if (this.callEditedInfo.modal_title === "タイトルを編集") {
          interactionUpdate(
            INTERACTION_POINT.UPDATE_CALL_TITLE,
            `タイトルを編集`,
            this.callEditedInfo.session_id
          );
        } else {
          interactionUpdate(
            INTERACTION_POINT.UPDATE_CALL_NOTES,
            `ノートを編集`,
            this.callEditedInfo.session_id
          );
        }
          
        });
    },
  },
};
</script>

<style scoped>
.offset-title {
  font-size: 18px;
  font-weight: 500;
}
.button-cancel {
  width: 140px;
  height: 40px;
  border-radius: 6px;
  border-width: 1px;
  padding-top: 7.5px;
  padding-right: 20px;
  padding-bottom: 7.5px;
  padding-left: 20px;
  margin: 6px;
  background: #e4e4e4;
  border: 1px solid #e2e8f0;
  color: #3f4652;
}
.button-save {
  width: 140px;
  height: 40px;
  border-radius: 6px;
  padding-top: 7.5px;
  padding-right: 16px;
  padding-bottom: 7.5px;
  padding-left: 16px;
  margin: 6px;
  background: #26bec8;
  box-shadow: 0px 4px 12px 0px #00000014;
  color: white;
}
.text-field {
  background-color: white;
  border: 0.5px solid #e2e8f0;
  border-style: none;
}
.input-label {
  color: #595959;
  font-size: 14px;
  font-weight: 400;
}
</style>
